import BaseService from "./BaseService";
import { unwrapResponse } from "./unwrapResponse";
/** Một `group_id` chỉ 1 request read in-flight + throttle — tránh double call (sidebar + Messager focus). */
const readGroupChatInflight = new Map();
let readGroupChatLastAt = new Map();
const READ_GROUP_CHAT_MIN_INTERVAL_MS = 3000;
export default class ChatService extends BaseService {
    static async getChatGroups(params = {}) {
        const res = await this.get(`/chat/groups`, params);
        return unwrapResponse(res);
    }
    static async getChatBotGroups(params = {}) {
        const res = await this.get(`/chat/groups/search`, params);
        return unwrapResponse(res);
    }
    static async createGroupChat(params = {}) {
        const res = await this.post(`/chat/groups`, params);
        return unwrapResponse(res);
    }
    static async createMessageChat(params = {}) {
        const res = await this.post(`/chat/groups/message`, params);
        return unwrapResponse(res);
    }
    static async getMessageList(params = {}) {
        const res = await this.get(`/chat/groups/message`, params);
        return unwrapResponse(res);
    }
    static async createReadGroupChat(params = {}) {
        const groupId = String(params.group_id ?? "");
        const key = groupId || "_";
        const existing = readGroupChatInflight.get(key);
        if (existing) {
            return await existing;
        }
        const now = Date.now();
        const last = readGroupChatLastAt.get(key) ?? 0;
        if (groupId && now - last < READ_GROUP_CHAT_MIN_INTERVAL_MS) {
            return { status: true, data: {}, message: "" };
        }
        const run = async () => {
            try {
                const res = await this.post(`/chat/groups/read`, params);
                const data = unwrapResponse(res);
                if (data && data.status) {
                    readGroupChatLastAt.set(key, Date.now());
                }
                return data;
            }
            finally {
                readGroupChatInflight.delete(key);
            }
        };
        const p = run();
        readGroupChatInflight.set(key, p);
        return await p;
    }
    static async getUnreadGroupChat() {
        const res = await this.get(`/chat/groups/unread-count`);
        return unwrapResponse(res);
    }
    static async getMembersGroup(params = {}) {
        const res = await this.get(`/chat/groups/members`, params);
        return unwrapResponse(res);
    }
    static async leaveGroupChat(params = {}) {
        const res = await this.post(`/chat/groups/leave`, params);
        return unwrapResponse(res);
    }
    static async dissolveGroupChat(params = {}) {
        const res = await this.post(`/chat/groups/dissolve`, params);
        return unwrapResponse(res);
    }
    static async updateNameGroupChat(params = {}) {
        const res = await this.post(`/chat/groups/name`, params);
        return unwrapResponse(res);
    }
    static async addMemberGroupChat(params = {}) {
        const res = await this.post(`/chat/groups/add-member`, params);
        return unwrapResponse(res);
    }
    static async updateAvatarGroup(params = {}) {
        const res = await this.post(`/chat/groups/avatar`, params);
        return unwrapResponse(res);
    }
    static async getChatConvesations(params = {}) {
        const res = await this.get(`/chat/groups/search`, params);
        return unwrapResponse(res);
    }
    static async checkChatExits(params = {}) {
        const res = await this.post(`/chat/groups/check-group-chat`, params);
        return unwrapResponse(res);
    }
    static async notificationConvensation(params = {}) {
        const res = await this.post(`/chat/groups/${params.group_id}/stage`, params);
        return unwrapResponse(res);
    }
    static async messageRecall(params = {}) {
        const res = await this.post(`/chat/groups/${params.chat_message_id}/recall`, params);
        return unwrapResponse(res);
    }
    static async reactionMessage(params = {}) {
        const res = await this.post(`/chat/messages/${params.message_id}/reaction`, params);
        return unwrapResponse(res);
    }
    static async getFilesGroupChat(params = {}) {
        const res = await this.get(`/chat/groups/${params.group_id}/files/${params.type}`, params);
        return unwrapResponse(res);
    }
    static async getRecentAnnouncements(params = {}) {
        const res = await this.get(`/chat/groups/recent-announcements`, params);
        return unwrapResponse(res);
    }
    static async getGroupAnnouncements(groupId, params = {}) {
        const res = await this.get(`/chat/groups/${groupId}/announcements`, params);
        return unwrapResponse(res);
    }
    static async removeMemberChatGroup(params = {}) {
        const res = await this.post(`/chat/groups/remove-member`, params);
        return unwrapResponse(res);
    }
    static async getListReaction(params = {}) {
        const res = await this.get(`/chat/groups/list-reaction/${params.chat_message_id}`, params);
        return unwrapResponse(res);
    }
    static async getMessageOriginal(params = {}) {
        const res = await this.get(`/chat/messages/original-message`, params);
        return unwrapResponse(res);
    }
    static async getPinListMessage(params = {}) {
        const res = await this.get(`/chat/messages/pin-messages/${params.group_id}`, params);
        return unwrapResponse(res);
    }
    static async pinMessage(params = {}) {
        const res = await this.post(`/chat/messages/pin`, params);
        return unwrapResponse(res);
    }
    static async unPinMessage(params = {}) {
        const res = await this.post(`/chat/messages/unpin`, params);
        return unwrapResponse(res);
    }
    static async pinMessagePriority(params = {}) {
        const res = await this.post(`/chat/messages/pin-priority`, params);
        return unwrapResponse(res);
    }
    static async setMemberAdminChatGroup(params) {
        const res = await this.post(`/chat-group/${params.group_id}/admin`, params);
        return unwrapResponse(res);
    }
    static async editMessageChat(params = {}) {
        const res = await this.post(`/chat/groups/edit-message`, params);
        return unwrapResponse(res);
    }
    static async requestJoinGroup(params = {}) {
        const res = await this.post(`/chat-group/${params.group_id}/request-to-join/${params.user_id}`);
        return unwrapResponse(res);
    }
    static async getListRequestJoinChatGroup(params = {}) {
        const res = await this.get(`/chat-group/${params.group_id}/pending-users/`, params);
        return unwrapResponse(res);
    }
    static async getAllPendingJoinRequests(params = {}) {
        const res = await this.get('/chat-group/pending-join-requests', params);
        return unwrapResponse(res);
    }
    static async browseRequestJoinChatGroup(params = {}) {
        const res = await this.post(`/chat-group/${params.group_id}/browse-request/${params.user_id}`, params);
        return unwrapResponse(res);
    }
    static async pinChatGroup(params = {}) {
        const res = await this.post(`/chat/groups/pin-chat-group`, params);
        return unwrapResponse(res);
    }
    static async getChatNotifications(params = {}) {
        const res = await this.get(`/chat-notification`, params);
        return unwrapResponse(res);
    }
    static async readChatNotification(params = {}) {
        const res = await this.post(`/chat-notification/${params.chat_notification_id}/read`);
        return unwrapResponse(res);
    }
    static async hiddenChatGroup(params = {}) {
        const res = await this.post(`/chat/groups/hidden-chat-group`, params);
        return unwrapResponse(res);
    }
    static async getMembersMention(params = {}) {
        const res = await this.get(`/chat/groups/mention-members`, params);
        return unwrapResponse(res);
    }
    static async searchMessageInGroup(params = {}) {
        const res = await this.get(`/chat/messages/search`, params);
        return unwrapResponse(res);
    }
    static async votePoll(pollId, params = {}) {
        const res = await this.post(`/polls/${pollId}/vote`, params);
        return unwrapResponse(res);
    }
    static async votePollBatch(pollId, params = {}) {
        const res = await this.post(`/polls/${pollId}/vote-batch`, params);
        return unwrapResponse(res);
    }
    static async getPollDetail(pollId) {
        const res = await this.get(`/polls/${pollId}`);
        return unwrapResponse(res);
    }
    static async addOptionPoll(poll_id, params = {}) {
        const res = await this.post(`/polls/${poll_id}/add-option`, params);
        return unwrapResponse(res);
    }
    static async createChatBotMessage(chatGroupId, params = {}) {
        const res = await this.post(`/chat-groups/${chatGroupId}/message-chat-bot`, params, 'ADMIN');
        return unwrapResponse(res);
    }
    static async getBranchesTeams(params = {}) {
        const res = await this.get(`/teams`, params);
        return unwrapResponse(res);
    }
    static async getPackages(params = {}) {
        const res = await this.get(`/stickers/packages`, params);
        return unwrapResponse(res);
    }
    static async userTyping(params = {}) {
        const res = await this.get(`/chat/groups/${params.group_id}/user-typing`, params);
        return unwrapResponse(res);
    }
    static async deleteReaction(params = {}) {
        const res = await this.post(`/chat/messages/delete/reaction`, params);
        return unwrapResponse(res);
    }
}
